import React from 'react';
import {Provider} from 'react-redux'
import store from './redux/store'
import {BrowserRouter} from 'react-router-dom';
import {MuiPickersUtilsProvider} from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import './styles/index.scss'
import Root from 'pages/Root';
import ThemeProvider from 'theme/ThemeProvider';
import moment from 'moment';
import 'moment/locale/pl'
// import { hotjar } from 'react-hotjar';
// import Endpoints from 'constants/Endpoints'

function App() {
    moment.locale('pl')
    //hotjar.initialize(Endpoints.hotJarSettings.hjid, Endpoints.hotJarSettings.hjsv);
    return (
        <Provider store={store}>
            <BrowserRouter>
                <ThemeProvider>
                    <MuiPickersUtilsProvider utils={MomentUtils}>
                        <Root/>
                    </MuiPickersUtilsProvider>
                </ThemeProvider>
            </BrowserRouter>
        </Provider>
    );
}

export default App;
